export const GROUP_SEARCH = 'GROUP_SEARCH';
export const GROUP_SEARCH_SUCCESS = 'GROUP_SEARCH_SUCCESS';
export const GROUP_SEARCH_FAILED = 'GROUP_SEARCH_FAILED';
